import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVector = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={18} height={15} fill='currentColor' {...props}>
    <path d='m17.094 1.325-2.587 12.2c-.195.861-.704 1.076-1.427.67l-3.942-2.904-1.902 1.829c-.21.21-.387.386-.792.386l.283-4.014 7.306-6.601c.317-.284-.07-.44-.494-.157L4.507 8.42.62 7.203c-.845-.264-.86-.845.176-1.25L16.003.092c.704-.264 1.32.157 1.091 1.232' />
  </svg>
);
export default SvgVector;
